import { createContext, useContext, useState, useEffect } from 'react';
import { categoriesApi } from '../services/api';

const CategoriesContext = createContext();

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [subSubcategories, setSubSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const data = await categoriesApi.getAll();
        if (data?.categories) {
          setCategories(data.categories);
          setSubcategories(data.subcategories || []);
          setSubSubcategories(data.subSubcategories || []);
        }
      } catch (err) {
        console.error('Failed to load categories:', err);
      } finally {
        setLoading(false);
      }
    };
    loadCategories();
  }, []);

  const getSubcategoriesForCategory = (categoryId) => 
    subcategories.filter(s => s.category_id === categoryId);

  const getSubSubcategoriesForSubcategory = (subcategoryId) => 
    subSubcategories.filter(ss => ss.subcategory_id === subcategoryId);

  const value = {
    categories,
    subcategories,
    subSubcategories,
    loading,
    getSubcategoriesForCategory,
    getSubSubcategoriesForSubcategory
  };

  return (
    <CategoriesContext.Provider value={value}>
      {children}
    </CategoriesContext.Provider>
  );
}

export function useCategories() {
  const context = useContext(CategoriesContext);
  if (!context) {
    throw new Error('useCategories must be used within a CategoriesProvider');
  }
  return context;
}